export default __webpack_public_path__ + "static/media/folded-hands.99245b27.png";